/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
    // 倒计时
    function getRandomNum(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
    }

    let endTimeG;

    function cutDownTime() {
        let nowTime = new Date();
        let endTime = new Date(endTimeG);

        let leftTime = endTime.getTime() - nowTime.getTime();
        if (leftTime < 0) {
            setupNewCountdown();
            leftTime = 0;
        }
        let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
            leftM = Math.floor((leftTime / (1000 * 60)) % 60),
            leftS = Math.floor((leftTime / 1000) % 60);
        leftH = leftH >= 10 ? leftH : "0" + leftH;
        leftM = leftM >= 10 ? leftM : "0" + leftM;
        leftS = leftS >= 10 ? leftS : "0" + leftS;

        return {
            hour: leftH,
            minute: leftM,
            second: leftS,
        };
    }

    function setupNewCountdown() {
        const randomHour = getRandomNum(1, 9);
        const currentTime = new Date();
        endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
    }
    let intervalId;

    function getCutDownTime() {
        setupNewCountdown();
        if (intervalId) clearInterval(intervalId);
        intervalId = setInterval(function () {
            let cutDownTimeText = cutDownTime();
            $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
            $(".sp_top_cut_down .sp_left_view .sp_minute").html(
                cutDownTimeText.minute
            );
            $(".sp_top_cut_down .sp_left_view .sp_second").html(
                cutDownTimeText.second
            );
        }, 1000);
    }

    getCutDownTime();

    // 顶部轮播
    new Swiper(".sp-swiper-fade-top", {
        spaceBetween: 10,
        effect: "fade",
        autoplay: {
            disableOnInteraction: false,
            delay: 2000,
        },
        speed: 1000,
        loop: true,
    });

    jQuery(".sp-scroll2").slide({
        mainCell: ".nav-imgs",
        autoPlay: true,
        effect: "leftMarquee",
        interTime: 12,
        vis: 1,
        scroll: 1,
    });

    // jQuery(".sp3-users-scroll").slide({
    //     mainCell: ".sp3-users-list",
    //     autoPlay: true,
    //     effect: "leftMarquee",
    //     interTime: 10,
    //     vis: 1,
    //     scroll: 1,
    // });

    new Swiper(".sp-swiper-fade", {
        autoplay: {
            disableOnInteraction: false,
            delay: 3500,
        },
        spaceBetween: 0,
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
    });

    new Swiper(".sp-swiper-scroll-top", {
        spaceBetween: 160,
        loop: true,
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
            delay: 0,
        },
        speed: 8000,
        slidesPerView: "auto",
    });
    new Swiper(".sp-swiper-scroll-top-m", {
        spaceBetween: 250,
        loop: true,
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
            delay: 0,
        },
        speed: 10000,
        slidesPerView: "auto",
    });

    new Swiper(".sp-swiper2", {
        autoplay: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        slideShadows: true,
        slidesPerView: "auto",
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        // pagination: {
        //   el: ".sp-pagination",
        //   clickable: true,
        // },
    });

    new Swiper(".sp-swiper3", {
        autoplay: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        slideShadows: true,
        slidesPerView: "auto",
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        pagination: {
            el: ".sp-pagination",
            clickable: true,
        },
    });

    new Swiper(".sp-swiper1", {
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
        },
        spaceBetween: 20,
        loop: true,

        pagination: {
            el: ".sp-pagination1",
            clickable: true,
        },
    });

    new Swiper(".sp-swiper1-mobile", {
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
        },
        spaceBetween: 20,
        loop: true,
        pagination: {
            el: ".sp-pagination1-m",
            clickable: true,
        },
    });

    // let _swiper = new Swiper(".sp-swiper-pro", {
    //     speed: 1,
    //     spaceBetween: 0,
    // });
    let _swiper = null;

// 只在元素存在时初始化Swiper
if (document.querySelector(".sp-swiper-pro")) {
    _swiper = new Swiper(".sp-swiper-pro", {
        speed: 1,
        spaceBetween: 0,
    });
}

    new Swiper(".sp-features-swiper", {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        loop: true,
    });

    new Swiper(".sp-solution-swiper", {
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        loop: true,
        navigation: {
            nextEl: ".sp-solution-swiper .swiper-button-next",
            prevEl: ".sp-solution-swiper .swiper-button-prev",
        },
        pagination: {
            el: ".sp-solution-swiper .swiper-pagination",
            clickable: true,
        },
    });

    new Swiper(".sp-problem-swiper", {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        loop: true,
    });

    new Swiper(".sp-part4-swiper", {
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        loop: true,
        pagination: {
            el: ".sp-part4-swiper .swiper-pagination",
            clickable: true,
        },
    });

    
    new Swiper(".sp-swiper-8", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 0,
    },
    speed: 6000,
    slidesPerView: "auto",
    spaceBetween: 30,
    loop: true,
  });

       let prods = window.product
  function getCur(){
    let color = $('#sp-color div.active').attr('data-val')
    let type = $('#sp-num div.active').attr('data-val')
    console.log("type",type)
    // let num = $('#sp-num div.active').attr('data-val')
    // return prods.filter(item=> item.option1 == color && item.option2 == type )[0]
    return prods.filter(item=> item.option1 == color&& item.option2==type)[0]
  }
  function changePrice(){
    let num = $('#calcNumber').val()
    let price = (getCur().price * num / 100).toFixed(2)
    let compare = (getCur().compare_at_price * num / 100).toFixed(2)
    $('#sp_price1').html(price)
    $('#sp_price2').html(compare)
    let off_font = 100 - Math.ceil(price / compare * 100)
    console.log(price,compare,off_font)
     $(".font-off").html(off_font)
  }
    $(" .sp-option").click(function () {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");

        let colorOptions = $(" .sp-color .sp-option.active").index();
        let numOptions = $(" .sp-num .sp-option.active").index();

        _index = colorOptions + numOptions * 4;

        // $(".sp_product_part.sp_mobile .sp-img-p")
        //   .eq(_index)
        //   .addClass("active")
        //   .siblings()
        //   .removeClass("active");

        // _swiper.slideToLoop(_index);
        // 只有在_swiper已初始化时才调用slideToLoop
    if (_swiper && typeof _swiper.slideToLoop === 'function') {
        _swiper.slideToLoop(_index);
    }
        changePrice()
    });

    function mainRender() {
        $(function () {
            $("#root").css("zoom", "normal");
            if (document.body.clientWidth <= 1080) {
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
            } else {
                const scale = document.body.clientWidth / 1920;
                $("#root").css("zoom", scale);
            }

            window.addEventListener(
                "resize",
                (function () {
                    var timer;
                    return function () {
                        if (timer) clearTimeout(timer);
                        timer = setTimeout(function () {
                            $("#root").css("zoom", "normal");
                            if (document.body.clientWidth <= 1080) {
                                let scale = document.body.clientWidth / 1080;
                                $("#root").css("zoom", scale);
                            } else {
                                const scale = document.body.clientWidth / 1920;
                                $("#root").css("zoom", scale);
                            }
                        }, 100);
                    };
                })()
            );
        });

        function lazyLoadImages() {
            // 懒加载
            const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
            const config = {
                rootMargin: "0px 0px 1300px 0px",
                threshold: 0,
            };

            const lazyLoadObserver = new IntersectionObserver(function (
                entries,
                observer
            ) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        // 当图片进入视口时
                        const image = entry.target;
                        const dataSrc = image.getAttribute("data-src");
                        image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
                        lazyLoadObserver.unobserve(image); // 停止观察该图片
                    }
                });
            },
                config);

            images.forEach(function (image) {
                lazyLoadObserver.observe(image); // 开始观察每个图片
            });
        }

        function preloadImages(imageArray) {
            // 预加载
            // 检查数组数据结构
            if (Array.isArray(imageArray[0])) {
                // 处理二维数组
                imageArray.forEach((subArray) => {
                    subArray.forEach((url) => {
                        const img = new Image();
                        img.src = url;
                    });
                });
            } else {
                // 处理一维数组
                imageArray.forEach((url) => {
                    const img = new Image();
                    img.src = url;
                });
            }
        }

        lazyLoadImages();

        // preloadImages();

        // 找到所有跳转套餐的锚点链接
        var links = document.querySelectorAll('a[href^="#shopping"]');
        links.forEach(function (link) {
            link.addEventListener("click", function (event) {
                event.preventDefault(); // 阻止默认的跳转行为
                // 方式一
                const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
                const offsetTop =
                    document.body.clientWidth <= 1080 ?
                        targetElement.offsetTop - $(".sp-nav").height() :
                        targetElement.offsetTop;

                let sptop = document.body.clientWidth <= 1080 ? 50 : 80;

                window.scroll({
                    top: offsetTop * $("div#root").css("zoom") -
                        sptop * $("div#root").css("zoom"),
                    behavior: "smooth", // 使用 smooth 实现平滑滚动
                });
            });
        });

        // IOS字体多了间距的处理 给节点添加 sp_system 类名
        // 判断当前用户是安卓端还是iOS端
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        var isAndroid = /android/i.test(userAgent);
        var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
        var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

        if (isAndroid) {
            console.log("Android");
        } else if (isIOS) {
            console.log("iOS");
        } else if (isPC) {
            console.log("PC");
        } else {
            $(".sp_system").css("letter-spacing", "-4px");
        }

        // 平整的左右滑动轮播
        var carouselSwiper = new Swiper("#carousel .swiper", {
            grabCursor: true,
            centeredSlides: false,
            slidesPerView: 'auto',
            spaceBetween: 20,
            loop: true,
            autoplay: {
                delay: 0,
                stopOnLastSlide: false,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
                reverseDirection: false,
            },
            freeMode: {
                enabled: true,
                momentum: false,
            },
            speed: 5000,
            on: {
                touchEnd: function () {
                    var swiper = this;
                    setTimeout(function () {
                        swiper.autoplay.stop();
                        swiper.autoplay.start();
                    }, 50);
                },
                slideChangeTransitionEnd: function () {
                    var swiper = this;
                    setTimeout(function () {
                        if (!swiper.autoplay.running) {
                            swiper.autoplay.stop();
                            swiper.autoplay.start();
                        }
                    }, 50);
                }
            }
        });

        // 定期检查并重启自动播放
        setInterval(function () {
            if (carouselSwiper && carouselSwiper.autoplay && !carouselSwiper.autoplay.running) {
        carouselSwiper.autoplay.start();
            }
        }, 1000);

    }

    mainRender();

    let sp_price1 = 49.00;
    let sp_price2 = 100.00;

    function calcTotal(price, num) {
        let result = Number(price) * Number(num);
        return result.toFixed(2).replace('.', ',');
    }
    $(".sp-reduce").click(function () {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) - 1;
        if (num > 0) {
            input.value = num;
        }
       changePrice()
    });
    $(".sp-add").click(function () {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) + 1;
        input.value = num;
      changePrice()
    });
          $('.sp_buy_now').click(function(){
      let num = $('#calcNumber').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
    })
    // 标题文本渐出
    const graduallyList = document.getElementsByClassName("gradually");
    for (let gradually of graduallyList) {
        const spans = gradually.querySelectorAll("span");
        const paragraph = gradually.querySelector(".sp-sub-title");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // 给每个 span 和 i 动画
                        spans.forEach((span, index) => {
                            span.style.animation = `swift-up-fade 0.5s ease forwards`;
                            span.style.animationDelay = `${index * 0.1}s`;

                            const i = span.querySelector("i");
                            if (i) {
                                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                                i.style.animationDelay = `${index * 0.1}s`;
                            }
                        });

                        // 段落
                        const totalDelay = spans.length * 0.1 + 0.3;
                        if (paragraph) {
                            paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
                            paragraph.style.animationDelay = `${totalDelay}s`;
                        }

                        observer.unobserve(gradually);
                    }
                });
            }, {
            threshold: 0.3,
        }
        );
        observer.observe(gradually);
    }

    // 菜单
    $(".sp-menu-btn").click(function (e) {
        $(".sp-menu-mask").show();
    });

    $(".sp-menu-mask").click(function (e) {
        // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
        // } else {
        $(".sp-menu-mask").hide();
        // }
    });

    // 滚动隐藏顶部
    if (
        $(window).scrollTop() >
        $(".sp_header").height() * $("div#root").css("zoom")
    ) {
        $(".sp_header-wrap").addClass("sp-fixed");
    } else {
        $(".sp_header-wrap").removeClass("sp-fixed");
    }

    // 底部按钮：首屏隐藏，向下滚动后显示
    function checkBottomBtnVisibility() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();
        var zoom = parseFloat($("div#root").css("zoom")) || 1;
        // 当滚动超过一屏高度时显示底部按钮
        if (scrollTop > windowHeight * zoom * 0.5) {
            $(".sp-btn-style2.sp-fixed-bottom").addClass("sp-show");
        } else {
            $(".sp-btn-style2.sp-fixed-bottom").removeClass("sp-show");
        }
    }
    
    // 初始检查
    checkBottomBtnVisibility();

    $(window).scroll(function () {
        if (
            $(window).scrollTop() >
            $(".sp_header").height() * $("div#root").css("zoom")
        ) {
            $(".sp_header-wrap").addClass("sp-fixed");
        } else {
            $(".sp_header-wrap").removeClass("sp-fixed");
        }
        
        // 检查底部按钮显示状态
        checkBottomBtnVisibility();
    });

    $(document).on("click", ".sp_buy_now", function () {
        console.log("xxx111");
    });

    let initNum = 0;
    $(document).on("click", ".sp_add_cart", function () {
        // 购物车加购动效

        $(this).children("img").addClass("on");
        $(".sp-cart .num").show();
        setTimeout(function () {
            $(" .cart-btn").children("img").removeClass("on");
        }, 500);
        $(" .sp-cart").addClass("on");
        setTimeout(function () {
            $(".sp-cart").removeClass("on");
        }, 500);

        let spNum = $(".sp_product_part #calcNumber")[0].value;
        initNum += Number(spNum);

        // $("#calcNumber").val(1);
            var data = {
        id: getCur().id,
        quantity: spNum,
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            $(".cardNum").html(result.item_count);
            $('.cardNum').each(function () {
             $(this).html(result.item_count)
             $(this).removeClass("sp-gray")
            })
            
          });
        },
        dataType: "json",
      });
        // $(".cardNum").each(function () {
        //     $(this).html(initNum);
        // });
        // $(".cardNum").removeClass("sp-gray");
        // // handleAddToCart(initNum);

        var imgs = $(".sp_product_part .sp-combo-item.active").find(".sp-img-p").first();
        if (imgs.length === 0) {
            imgs = $(".sp_product_part .swiper-slide-active").find("img");
        }

        imgs.each(function () {
            var $img = $(this);
            var flyer = $img[0].cloneNode(true);
            flyer.classList.add("sp_clone");

            $(".sp_product_part").append(flyer);
            $(flyer).css({
                width: $img[0].width,
                height: $img[0].height,
                background: "#e7e9ef",
                position: "fixed",
                top: $img.offset().top - $(window).scrollTop(),
                left: $img.offset().left,
                "z-index": 99,
            });
            let finish;
            if (document.body.clientWidth <= 1080) {
                finish = $(".sp-btn-style2 .sp-cart");
                if (finish.length === 0) return;
                
                var cartOffset = finish.offset();
                var zoom = parseFloat($("#root").css("zoom")) || 1;
                var scrollTop = $(window).scrollTop();

                $(flyer).animate({
                    top: (cartOffset.top - scrollTop) / zoom,
                    left: (cartOffset.left+30 ) / zoom,
                    width: 30,
                    height: 30,
                    opacity: 0.4,
                },
                    1200,
                    "swing",
                    function () {
                        $(this).animate({
                            width: 0,
                            height: 0,
                            opacity: 0,
                        },
                            0,
                            function () {
                                $(this).detach();
                            }
                        );
                    }
                );
            } else {
            // PC端加购动效已禁用
            //   $(flyer).detach();
        finish = $(".sp_pc .sp-cart");
        $(flyer).animate(
          {
            top: finish[0].offsetTop,
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
          }
        });
    });

    // 问答 - 手风琴效果：点击展开当前项，关闭其他项
    $(".q-row").click(function () {
        var $currentItem = $(this).parent();
        // 如果当前项已展开，则关闭它
        if ($currentItem.hasClass("sp-show")) {
            $currentItem.removeClass("sp-show");
        } else {
            // 关闭所有其他项，展开当前项
            $(".sp-q-part .sp-item").removeClass("sp-show");
            $currentItem.addClass("sp-show");
        }
    });

    // 文本渐出动画
    const graduallyList2 = document.getElementsByClassName("sp-fade-box");
    for (let gradually2 of graduallyList2) {
        const paragraph2 = gradually2.querySelectorAll(".sp-ani");

        const observerAni = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        paragraph2.forEach((span, index) => {
                            span.style.animation = `sp-fade-in 1s ease forwards`;
                            span.style.animationDelay = `${index * 0.5 + 0.5}s`;
                        });

                        observerAni.unobserve(gradually2);
                    }
                });
            }, {
            threshold: 0.3,
        }
        );
        observerAni.observe(gradually2);
    }
    // 文本渐出动画
    const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
    for (let gradually3 of graduallyList3) {
        const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

        const observerAni = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        paragraph3.forEach((span, index) => {
                            span.style.animation = `sp-fade-left 1s ease forwards`;
                            span.style.animationDelay = `${index * 0.3 + 1}s`;
                        });

                        observerAni.unobserve(gradually3);
                    }
                });
            }, {
            threshold: 0.3,
        }
        );
        observerAni.observe(gradually3);
    }

    // 产品图片切换逻辑
    let currentColor = 'blue';
    let currentStrap = 'without';

    // function updateProductImage() {
    //     // 隐藏所有组合，显示当前组合
    //     const comboItems = document.querySelectorAll('.sp-combo-item');
    //     comboItems.forEach(item => {
    //         item.classList.remove('active');
    //         if (item.dataset.color === currentColor) {
    //             item.classList.add('active');
    //         }
    //     });
    // }
    // 根据选项下标计算图片索引
    function calculateImageIndex() {
        let colorIndex = $('#sp-color .sp-option.active').index();
        let numIndex = $('#sp-num .sp-option.active').index();

        // 计算总图片索引
        // 假设图片按以下顺序排列：
        let count = $('#sp-color .sp-option').length;
        let imageIndex = colorIndex  + numIndex * count;

        return imageIndex;
    }

    // 更新产品图片显示
    function updateProductImage() {
        let imageIndex = calculateImageIndex();

        // 显示对应的图片
        $('.sp-combo-item').removeClass('active').hide();
        $('.sp-combo-item[data-index="' + imageIndex + '"]')
            .addClass('active')
            .show();

        // 如果对应索引的图片不存在，显示第一张图
        if ($('.sp-combo-item[data-index="' + imageIndex + '"]').length === 0) {
            $('.sp-combo-item[data-index="0"]')
                .addClass('active')
                .show();
        }
    }

    // 页面加载时初始化
    // $(document).ready(function() {
    //     updateProductImageSimple(); // 或 updateProductImage()
    // });

    // 获取当前选中的变体（根据你的业务逻辑调整）
    function getCur() {
        let color = $('#sp-color div.active').attr('data-val');
        let type = $('#sp-num div.active').attr('data-val');

        return prods.filter(item => item.option1 == color && item.option2 == type)[0];
    }

    // 颜色选项点击
    const colorOptions = document.querySelectorAll('#sp-color .sp-option');
    colorOptions.forEach((option) => {
        option.addEventListener('click', function () {
            colorOptions.forEach(opt => opt.classList.remove('active'));
            this.classList.add('active');
            currentColor = this.dataset.color;
            updateProductImage();
        });
    });

    // 第二个规格选项点击
    const strapOptions = document.querySelectorAll('#sp-num .sp-option');
    strapOptions.forEach((option) => {
        option.addEventListener('click', function () {
            strapOptions.forEach(opt => opt.classList.remove('active'));
            this.classList.add('active');
            currentStrap = this.dataset.strap;
            updateProductImage();
        });
    });

    // sp-part3 用户列表走马灯效果（仅移动端）
    function initUserCarousel() {
        const usersList = document.querySelector('.sp-part3 .sp3-users-list');
        if (!usersList) return;
        
        // 检测是否为移动端
        if (window.innerWidth > 750) return;
        
        let scrollInterval;
        let scrollPosition = 0;
        const scrollSpeed = 1;
        const scrollDelay = 30;
        
        function autoScroll() {
            scrollPosition += scrollSpeed;
            const maxScroll = usersList.scrollWidth - usersList.clientWidth;
            
            if (scrollPosition >= maxScroll) {
                scrollPosition = 0;
            }
            
            usersList.scrollLeft = scrollPosition;
        }
        
        function startAutoScroll() {
            if (scrollInterval) clearInterval(scrollInterval);
            scrollInterval = setInterval(autoScroll, scrollDelay);
        }
        
        function stopAutoScroll() {
            if (scrollInterval) {
                clearInterval(scrollInterval);
                scrollInterval = null;
            }
        }
        
        // 触摸时暂停
        usersList.addEventListener('touchstart', function() {
            stopAutoScroll();
        });
        
        usersList.addEventListener('touchend', function() {
            scrollPosition = usersList.scrollLeft;
            setTimeout(startAutoScroll, 2000);
        });
        
        // 开始自动滚动
        startAutoScroll();
    }
    
    // 延迟初始化走马灯
    setTimeout(initUserCarousel, 1000);
});